module.exports = __webpack_public_path__ + "static/quiz_stage_10_bg-26c1c9483f600505b9036465e8035af3.svg";